export const RESET_DATA = 'RESET_DATA';
export const SET_CUSTOM_PATTERNS = 'SET_CUSTOM_PATTERNS';
export const SET_DELETED_FOUND_PATTERNS = 'SET_DELETED_FOUND_PATTERNS';
export const SET_FOUND_PATTERNS = 'SET_FOUND_PATTERNS';
export const SET_MATCHING_FILES = 'SET_MATCHING_FILES';
export const SET_SELECTED_PATHS = 'SET_SELECTED_PATHS';
export const SET_SELECTED_PATTERNS = 'SET_SELECTED_PATTERNS';
